import React from "react"

interface IProps {
  columns: any[]
  data: any[]
}

const Table = ({ columns, data }: IProps) => {
  return (
    <div className="table-container">
      <table className="table is-striped is-bordered is-fullwidth">
        <thead>
          <tr>
            {columns.map((c, i) => {
              if (!c) return null
              const { header } = c
              return <th key={`table-header-${i}`}>{header}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr key={`table-row-${i}`}>
              {columns.map((c, ci) => {
                if (!c) return null
                const { accessor } = c
                return <td key={`table-column-${ci}`}>{accessor(d, i)}</td>
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
